/*
 * Replace the entire path with new parameters or update a single query parameter
 * Example to replace entire path: updatePathShallow("newParam=newValue", { mode: "replace" });
 * Example to update a single query parameter: updatePathShallow("newValue", { mode: "update", param: "paramName" });
 */
export const updatePathShallow = (input: string, options = { mode: "update", param: "" }) => {
  const url = new URL(window.location.href)
  const searchParams = new URLSearchParams(url.search)

  if (options.mode === "replace") {
    // Replace the entire path with the new params
    url.search = `?${input.toString()}`
  } else if (options.mode === "update" && options.param) {
    // Update a single query parameter
    searchParams.set(options.param, input)
    url.search = searchParams.toString()
  } else {
    // Default to updating the entire path if no valid mode is provided
    url.search = `?${input.toString()}`
  }

  window.history.pushState(null, "", url.toString())
}
